module.exports = __webpack_public_path__ + "img/pen-tool-minus.d2c04833.svg";